"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWcaId = void 0;
function isWcaId(wcaId) {
    return /^\d{4}[A-Z]{4}\d{2}$/.test(wcaId.toUpperCase());
}
exports.isWcaId = isWcaId;
//# sourceMappingURL=wcaId.js.map